import type { CSSProperties } from "react";
import styled, { css } from "styled-components";

export const TextWrapper = styled.div<{ isExpanded?: boolean; maxLines?: CSSProperties["WebkitLineClamp"] }>`
  ${(props) =>
    !props.isExpanded &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      -webkit-line-clamp: ${props.maxLines};
      position: relative;
    `}
`;

export const SeeMore = styled.span<{ $seeMoreBackground?: string }>`
  position: absolute;
  bottom: 0;
  right: 0;

  padding-left: ${(props) => props.theme.spacing(1.25)};
  cursor: pointer;
  background-color: ${(props) => props.$seeMoreBackground ?? "white"};

  font-size: 0.7em;
  font-weight: 400;
  line-height: inherit;
  ${({
    theme: {
      typography: { getStyles, variant, fontWeight },
    },
  }) => getStyles(variant.body2, fontWeight.bold)};
  text-decoration: none;
  color: ${({ theme }) => theme.palette.textBrandOnSurface};
`;

export const SeeMoreLinkStyle = styled.span`
  cursor: pointer;
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.subtitle2)};
  color: ${({ theme }) => theme.palette.textLinkOnSurface};
`;
